import { render, staticRenderFns } from "./FamiliariTable.vue?vue&type=template&id=7b78bac5&"
import script from "./FamiliariTable.vue?vue&type=script&lang=js&"
export * from "./FamiliariTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FamiliariTable.vue"
export default component.exports